// Initialize the worker
const workerInstance= new Worker(new URL("../workers/poseDetectionWorker.js", import.meta.url));
console.log("poseDetectionWorkerInstance is triggered", workerInstance);

export default workerInstance;
